import { makeApiUrl } from '../../http';
import { makeAuthorizeHttpClientDecorator } from '../../decorators';
import { HttpClient } from 'data/protocols/http';

export interface GetVendorEmailResponse {
  contactEmail: string;
  accountNumber: string;
}

export interface GetVendorEmailRequest {
  locationId: string;
  vendorId: string;
}

export class RemoteGetVendorEmail {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async get(params: GetVendorEmailRequest): Promise<GetVendorEmailResponse> {
    const { locationId, vendorId } = params;
    const requestUrl = makeApiUrl(`/reports/vendors/${vendorId}/info?locationId=${locationId}`);

    const response = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    return response.body;
  }
}

export const makeRemoteGetVendorEmail = (): RemoteGetVendorEmail => {
  return new RemoteGetVendorEmail('', makeAuthorizeHttpClientDecorator());
};
